export var CustomerForPaymentsJobStatus;
(function (CustomerForPaymentsJobStatus) {
    CustomerForPaymentsJobStatus["QUEUED"] = "queued";
    CustomerForPaymentsJobStatus["IN_PROGRESS"] = "in_progress";
    CustomerForPaymentsJobStatus["SUCCESS"] = "success";
    CustomerForPaymentsJobStatus["ERROR"] = "error";
})(CustomerForPaymentsJobStatus || (CustomerForPaymentsJobStatus = {}));
//# sourceMappingURL=types.js.map